import http from '../http'

export async function fetchCmsBootstrap() {
    return await http.post('/cms/bootstrap')
}

export async function saveCmsPage(payload) {
    return await http.post('/cms/pages/save', payload)
}

export async function saveCmsBanner(payload) {
    return await http.post('/cms/banners/save', payload)
}

export async function saveCmsServiceItem(payload) {
    return await http.post('/cms/services/save', payload)
}

export async function saveCmsCase(payload) {
    return await http.post('/cms/cases/save', payload)
}

// 仅允许为已归档项目补生成或复用案例草稿，发布仍沿用既有 CMS 流程。
export async function generateCmsCaseDraft(payload) {
    return await http.post('/cms/cases/generate-draft', payload)
}

export async function updateCmsPublishStatus(payload) {
    return await http.post('/cms/publish', payload)
}
